<script setup>
import TabContainer from "@/components/global-themed/tabs/TabContainer.vue";
import TabItem from "@/components/global-themed/tabs/TabItem.vue";
import {ref} from "vue";
import TrafficSourcesTable from "@/components/reporting/partials/TrafficSourcesTable.vue";
import ReferrersTable from "@/components/reporting/partials/ReferrersTable.vue";
import SourceGA from "@/components/reporting/partials/SourceGA.vue";

const props = defineProps({
  initialActiveTab: {
    type: String,
    default: 'traffic',
  },
});

const activeTab = ref(props.initialActiveTab);
</script>

<template>
  <div class="tw-flex-col tw-flex">
    <h3 class="tw-text-xl tw-text-font-primary tw-font-bold tw-font-sans tw-mb-6">
      Top Sources
    </h3>

    <div class="tw-border-2 tw-rounded-lg tw-h-full tw-flex-1">
      <TabContainer class="tw-m-8 tw-mb-2">
        <TabItem
          :active="activeTab === 'traffic'"
          class="tw-gap-2 tw-justify-center"
          @click="activeTab = 'traffic'"
        >
          <svg-vue
            icon="icons/traffic"
            class="tw-w-6 tw-h-6"
          />
          <span>Traffic Sources</span>
        </TabItem>
        <TabItem
          :active="activeTab === 'referrers'"
          class="tw-gap-2 tw-justify-center"
          @click="activeTab = 'referrers'"
        >
          <svg-vue
            icon="icons/referral"
            class="tw-w-6 tw-h-6"
          />
          <span>Referrers</span>
        </TabItem>
      </TabContainer>

      <div>
        <TrafficSourcesTable v-if="activeTab === 'traffic'" />
        <ReferrersTable v-if="activeTab === 'referrers'" />
      </div>

      <SourceGA class="tw-pt-2 tw-pb-2 tw-px-4" />
    </div>
  </div>
</template>
